import { Injectable } from '@angular/core';
import { AbstractReadOnlyDataProvider } from '@epicuro-next/data-providers/base-data-provider';
import {
  FilterQuery,
  Order,
  OrdersTotalResponse,
} from 'graphql-api/baskets-api-interfaces';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { OrdersGQL } from './../../queries/order-book-orders.gql';

export interface OrderModel {
  orders: Order[];
  totals: OrdersTotalResponse;
  afterKey: string;
}

@Injectable()
export class OrdersService implements AbstractReadOnlyDataProvider<OrderModel> {
  constructor(private ordersGQL: OrdersGQL) {}

  public getOrders(query: FilterQuery) {
    return this.ordersGQL
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map((queryResult) => ({
          orders: (queryResult.data.orders?.orders as Order[]) ?? [],
          afterKey: queryResult.data.orders?.pagination.afterKey as string,
          totals: queryResult.data.orders?.total as OrdersTotalResponse,
        })),
      );
  }

  public read(query: FilterQuery): Observable<OrderModel> {
    return this.getOrders(query) as Observable<OrderModel>;
  }
}
